"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});
Object.defineProperty(exports, "unstable_StrictModeFade", {
  enumerable: true,
  get: function get() {
    return _StrictModeFade.default;
  }
});

var _Fade = _interopRequireDefault(require("./Fade"));

var _StrictModeFade = _interopRequireDefault(require("./StrictModeFade"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Fade/index.js
// module id = 158
// module chunks = 0